import DealerSearchFilter from "./DealerSearchFilter"
import useStyles from "./styles"
import { useLanguage } from "../../lib/hooks/languageHooks"
import { strings as Localization } from "../../lib/Localization"
import {
    Box, Card, CardContent, Link, Typography
} from "@material-ui/core"
import React, { useState, useEffect } from "react"

const SearchDealer = ({ ...props }) => {
    const language = useLanguage()
    const [data, setData] = useState([])
    const [dealersByCountries, setDealersByCountries] = useState([])
    const classes = useStyles()

    const [filter, setFilter] = useState({
        place: null,
        webshop: null,
        country: null
    })

    const fetchDealerData = async () => {
        const response = await fetch("/files/DynamicPages/Resellers.json")
        return response.json()
    }

    const fetchDealerByCountry = async () => {
        const response = await fetch("/files/DynamicPages/DealersByCountry.json")
        return response.json()
    }

    useEffect(() => {
        setData([])
        setDealersByCountries([])
        setFilter({
            place: null,
            webshop: null,
            country: null
        })

        fetchDealerData().then(result => {
            result.sort((a, b) => a - b)
            setData(result.filter(x => x.customerNr !== ""))
        })

        fetchDealerByCountry().then(result => {
            result.sort((a, b) => a - b)
            setDealersByCountries(result)
        })
    }, [language])

    return (
        <Box alignContent="space-between" {...props}>
            <Typography>{Localization.searchDealer}</Typography>
            <>
                <Typography variant="h4">
                    {Localization.productsAvailablity}
                </Typography>
                <Typography className={classes.marginTop40}>
                    {Localization.viaOurDistributors}
                </Typography>
            </>
            <Box className={classes.dealerSearchFilterWrapper}>
                <DealerSearchFilter
                    data={data}
                    countryDealers={dealersByCountries}
                    filter={filter}
                    onChangeCountryDealers={
                        (event, value) => {
                            setFilter({ place: null, webshop: null, country: value })
                        }
                    }
                    onChangeDealerLocations={
                        (event, value) => {
                            setFilter({ place: value, webshop: null, country: null })
                        }
                    }
                    onChangeWebshops={
                        (event, value) => {
                            setFilter({ place: null, webshop: value, country: null })
                        }
                    }
                />
            </Box>
            <Box className={classes.resultGrid} id="dealers">
                {
                    data
                        ? data.filter(company => (
                            filter.place !== undefined && company.place === filter.place)
                            || (filter.webshop !== undefined && company.webShop === filter.webshop))
                            .map(company => {
                                const address = company.visitAddress
                                    ? company.visitAddress
                                    : company.postalAddress
                                return (
                                    <Box
                                        key={company.customerNr}
                                        className={classes.padding5}
                                    >
                                        <Card className={classes.resultCard}>
                                            <CardContent>
                                                <Box>
                                                    <Typography>
                                                        {
                                                            company.commonName !== ""
                                                                ? company.commonName
                                                                : company.organization
                                                        }
                                                    </Typography>
                                                    <Typography>{company.phone}</Typography>
                                                    <Typography>{address}</Typography>
                                                    <Link
                                                        href={`http://${company.website}`}
                                                        target="_blank"
                                                        rel="noopener"
                                                    >
                                                        <Typography>
                                                            {company.website}
                                                        </Typography>
                                                    </Link>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Box>
                                )
                            }) : null
                }
                {
                    filter.country ? dealersByCountries.filter(
                        x => x.Country === filter.country
                    ).map(company => (
                        <Box key={company.Company} className={classes.padding5}>
                            <Card className={classes.resultCard}>
                                <CardContent>
                                    <Box>
                                        <Typography>{company.Company}</Typography>
                                        <Typography>{company.Country}</Typography>
                                        <Typography>{company.Phone}</Typography>
                                        <Link
                                            href={company.Webpage}
                                            target="_blank"
                                            rel="noopener"
                                        >
                                            <Typography>{company.Webpage}</Typography>
                                        </Link>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                    )) : null
                }
            </Box>
        </Box>
    )
}

export default SearchDealer
